<template>
  <div class="login-container">
    <div class="login-main">
      <div class="login-header">
        <a href="http://www.spr-atm.com">
          <img src="@images/logo2.png" />
        </a>
        <div class="login">登录</div>
      </div>
      <el-card class="login-left">
        <star-cloud />
        <div class="title-wrapper">
          <div class="title-zh">
            云数据平台
          </div>
          <div class="title-en">
            Cloud data platform
          </div>
        </div>
        <ul class="function-wrapper">
          <li>云数据支持</li>
          <li>信息实时查询</li>
          <li>操作流程管控</li>
          <li>服务快速响应</li>
        </ul>
      </el-card>
      <el-card class="login-right">
        <img src="@images/cooperation_lib_logo.png"
             alt="合作库" />
        <div class="title">
          合作库-云数据平台
        </div>
        <el-form :model="loginForm"
                 :rules="loginFormRules"
                 autoComplete="on"
                 ref="loginFormRef">
          <el-form-item prop="username"
                        class="username-wrapper">
            <el-input placeholder="请输入用户名"
                      v-model="loginForm.username"
                      autoComplete="on"
                      clearable
                      size="mini"
                      prefix-icon="iconfont icon-user">
            </el-input>
          </el-form-item>
          <el-form-item prop="password"
                        class="password-wrapper">
            <el-input placeholder="请输入密码"
                      type="password"
                      autoComplete="on"
                      clearable
                      size="mini"
                      v-model="loginForm.password"
                      prefix-icon="iconfont icon-password">
            </el-input>
          </el-form-item>
        </el-form>
        <!-- <el-button class="login-btn"
                   :loading="isLoading"
                   @click.prevent="login">
          合作库登录
        </el-button> -->
        <div class="btn-wrapper">
          <!-- <a href="#"
             class="register-btn"
             @click="handleRegister">
            申请注册
          </a> -->
          <router-link to="/user-login"
                       class="user-login-btn">
            客户登录
          </router-link>
          <router-link to="/login"
                       class="supplier-login-btn">
            供应商登录
          </router-link>
        </div>
        <div class="register">
          <div class="forget-password"
               @click="handleForgetPassword">
            忘记密码
          </div>
          <span>|</span>
          <a href="#"
             @click="handleRegister">
            申请注册
          </a>
        </div>
        <!-- <div class="forget-password">
          忘记密码？
        </div> -->
      </el-card>
    </div>
    <div class="login-footer">
      Copyright &copy; 2019-2026 深圳市森普瑞科技 版权所有
      <!-- <cnzz /> -->
    </div>
    <el-dialog class="tips-dialog"
               title="温馨提示！"
               :visible.sync="isShowTips"
               :before-close="handleClose"
               top="30vh"
               width="445px">
      <p>
        合作库只针对参与合作库业务的用户进行开放，在合作库进行托管、寄售，租赁，维修等业务的用户我们会在第一时间将账号和密码发送到您指定邮箱，通过此账号您可以在合作库上查询您一切与合作库有关的信息!
      </p>
      <p>如有疑问请您联系：</p>
      <p>客服电话：0755-82405890-8931</p>
      <p>客服邮箱：atm8123@spr-atm.com</p>
    </el-dialog>
    <el-dialog class="tips-dialog"
               title="温馨提示！"
               :visible.sync="isShowTips2"
               :before-close="handleClose2"
               top="40vh"
               width="445px">
      <p>
        忘记密码请您联系：
      </p>
      <p>客服电话：0755-82405890-8931</p>
      <p>客服邮箱：atm8123@spr-atm.com</p>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import qs from 'qs'
import CNZZ from '@/components/public/CNZZ.vue'
import starCloud from '@/components/public/starCloud.vue'

export default {
  components: {
    // cnzz: CNZZ,
    'star-cloud': starCloud
  },
  data () {
    return {
      isLoading: false,
      isShowTips: false,
      isShowTips2: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      redirectUrl: this.$route.query.redirectUrl || '/home'
    }
  },
  created () { },
  mounted () {

  },
  methods: {
    login () {
      this.$refs.loginFormRef.validate(valid => {
        if (valid) {
          this.isLoading = true
          const params = {
            usernameOrEmailAddress: this.loginForm.username,
            password: this.loginForm.password
          }
          this.$http.post('https://api.atm020.com/api/Account', params)
            .then(res => {
              this.$message.success('登录成功！(Login Successfully!)')
              window.location.assign(`http://www.atm020.com/#/?token=${res.result.token}`)
              this.isLoading = false
            })
            .catch(err => {
              this.$message.error(err.data.message)
              this.isLoading = false
            })
        }
      })
    },
    handleRegister () {
      this.isShowTips = true
    },
    handleForgetPassword () {
      this.isShowTips2 = true
    },
    handleClose (done) {
      this.isShowTips = false
      done()
    },
    handleClose2 (done) {
      this.isShowTips2 = false
      done()
    }
  }
}
</script>
<style lang="less" scoped>
.login-container {
  height: 100%;
  min-height: 748px;
  position: relative;
  font-family: 'Source Han Sans CN';
  background: url('../assets/images/login_bg1.jpg') no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-main {
  width: 860px;
  height: 560px;
  position: relative;
}
.login-header {
  height: 50px;
  position: absolute;
  left: 0;
  top: -80px;
  display: flex;
  align-items: center;
  a {
    height: 100%;
    margin-right: 20px;
    cursor: pointer;
    img {
      height: 100%;
    }
  }
  .login {
    height: 100%;
    line-height: 50px;
    padding-left: 20px;
    border-left: 1px solid #e3ecf8;
    font-size: 25px;
    color: #f6f9fd;
  }
}
.login-left {
  background: none;
  width: 448px;
  height: 560px;
  box-shadow: 0px 16px 25px rgba(76, 99, 211, 0.54) !important;
  border: none;
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: 300;
  z-index: 5;
  /deep/ .el-card__body {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  .title-wrapper {
    position: absolute;
    left: 30px;
    top: 40px;
    text-align: right;
    .title-zh {
      font-size: 28px;
      color: #ffffff;
      opacity: 0.9;
      padding-bottom: 15px;
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 40%;
        height: 1px;
        background: #ffffff;
      }
    }
    .title-en {
      margin-top: 10px;
      font-size: 12px;
      color: #ffffff;
      opacity: 0.5;
    }
  }
}
.function-wrapper {
  position: absolute;
  left: 56px;
  top: 140px;
  list-style: disc;
  li {
    list-style: disc;
    color: #ffffff;
    font-size: 16px;
    margin-top: 24px;
    opacity: 0.8;
    &:nth-child(2) {
      margin-left: 12px;
      opacity: 0.7;
    }
    &:nth-child(3) {
      margin-left: 24px;
      opacity: 0.6;
    }
    &:nth-child(4) {
      margin-left: 36px;
      opacity: 0.5;
    }
  }
}
.login-right {
  background-color: #ffffff;
  width: 420px;
  height: 520px;
  box-shadow: 0px 16px 20px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  position: absolute;
  right: 0;
  top: 20px;
  padding: 40px 60px 20px 68px;
  /deep/ .el-card__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 56px;
    height: 56px;
    margin-bottom: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: 300;
    color: #4a62d0;
  }
}
.el-form {
  width: 100%;
  margin-top: 40px;
  .username-wrapper,
  .password-wrapper {
    width: 100%;
    border-bottom: 1px solid #99b9f2;
    /deep/ .iconfont {
      color: #99b9f2;
    }
    .el-input {
      /deep/ .el-input__inner {
        border: none;
        outline: none;
        input {
          border: none;
          outline: none;
        }
      }
      &::after {
        position: absolute;
        content: '*';
        top: -2px;
        left: -2px;
        color: #d36b75;
      }
    }
    /deep/ .el-form-item__content {
      line-height: 28px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #99b9f2 !important;
    }
    /deep/ input::-moz-placeholder {
      color: #99b9f2 !important;
    }
  }
}
.login-btn {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  background: linear-gradient(
    91deg,
    rgba(76, 98, 210, 1) 0%,
    rgba(125, 168, 237, 1) 100%
  );
  box-shadow: 0px 5px 10px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.co-lib-btn {
  width: 100%;
  height: 40px;
  margin-top: 30px;
  border: 1px solid #99b9f2;
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  color: #7da8ed;
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: #f5f5f5;
    color: #5670d7;
  }
}
.btn-wrapper {
  width: 100%;
  height: 40px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-login-btn,
  .supplier-login-btn {
    width: 140px;
    height: 40px;
    border: 1px solid #99b9f2;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    color: #7da8ed;
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: #f5f5f5;
      color: #5670d7;
    }
  }
}
.register {
  width: 100%;
  margin-top: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .forget-password {
    font-size: 14px;
    color: #99b9f2;
    bottom: 20px;
    user-select: none;
    cursor: pointer;
  }
  span {
    margin: 0 10px;
  }
  a {
    color: #7da8ed;
    user-select: none;
    cursor: pointer;
  }
}
.login-footer {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 16px;
  color: #ffffff;
}
.tips-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  p {
    font-family: 'Source Han Sans CN';
    text-indent: 2em;
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
